import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { HanyaBacaContext, tombolAksi } from "@/lib/hanyaBaca"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      // ⛔ TINGGI DINAIKKAN DI LAYAR SEMPIT — bukan kosmetik, ini penegakan
      // `memory/STANDAR_UI_KEAMANAN_ETAMSIOS.md` §E3: "Area yang bisa
      // disentuh minimal 44×44 piksel — jari lebih besar dari kursor."
      //
      // §E3 menyebut sendiri siapa yang menanggungnya: stock opname sambil
      // berjalan di gudang, serah terima di area penerimaan, CS mengecek
      // status saat tidak di meja. Ketiganya dikerjakan dengan jempol.
      //
      // ⚠ Bentuknya `h-11 md:h-8`, BUKAN `h-11` saja. Di desktop tombol
      //    44px terlalu gemuk dan merusak kepadatan tabel yang justru
      //    dipakai sepanjang hari dengan tetikus. Yang berubah hanya
      //    perilaku di bawah 768px — persis batas yang §E3 maksud dengan
      //    "layar kecil".
      size: {
        default: "h-11 md:h-9 px-4 py-2",
        sm: "h-11 md:h-8 rounded-md px-3 text-xs",
        lg: "h-11 md:h-10 rounded-md px-8",
        icon: "h-11 w-11 md:h-9 md:w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  // K236: akun Pemantau (hanya baca) — tombol aksi tidak ditampilkan. Penjaga sungguhan tetap server.
  const hanyaBaca = React.useContext(HanyaBacaContext)
  if (hanyaBaca && tombolAksi({ ...props, variant })) return null
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
